import { useState } from 'react';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

const GameInfoSection = () => {
  const [index, setIndex] = useState<number>(0);
  const [swiper, setSwiper] = useState<SwiperCore>();

  const handleClickPagination = (idx: number) => {
    swiper?.slideToLoop(idx);
    setIndex(idx);
  };

  const onSlideChange = () => {
    const idx = swiper?.realIndex || 0;
    setIndex(idx);
  };

  return (
    <>
      <div className='release' id='release-home'>
        <div className='container mx-auto flex flex-col items-center relative'>
          <div className='release-title'></div>
          <div className='release-scroll-paper'>
            <div className='swiper release-swiper'>
              <div className='swiper-wrapper'>
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  slidesPerView={1}
                  loop
                  autoplay={{ delay: 5000 }}
                  onInit={(swiper: SwiperCore) => {
                    setSwiper(swiper);
                  }}
                  onSlideChange={onSlideChange}
                >
                  <SwiperSlide>
                    <div className='swiper-slide'>
                      <p className='release-item'>
                        Đồng bộ đa nền tảng đa thiết bị. Thiết bị chỉ cần có tài
                        khoản Zalo là có thể truy cập bất cứ đâu cực kỳ tiện lợi
                        và bảo mật.
                      </p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className='swiper-slide'>
                      <p className='release-item'>
                        1 Click chơi ngay cực kỳ đơn giản và không tốn dung
                        lượng cài đặt. Thiết bị của bạn sẽ có nhiều dung lượng
                        để lưu trữ cá nhân hơn.
                      </p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className='swiper-slide'>
                      <p className='release-item'>
                        Trải nghiệm mượt mà và không nóng máy hao pin. Thiết bị
                        của bạn sẽ có tuổi thọ cao hơn.
                      </p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className='swiper-slide'>
                      <p className='release-item'>
                        Nhận quà miễn phí mỗi ngày bằng cách chia sẻ và mời bạn
                        bè trên Zalo.
                      </p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className='swiper-slide'>
                      <p className='release-item'>
                        Zalo Game Center sở hữu hơn 65 triệu người dùng sẵn sàng
                        tham gia cùng bạn. Cộng đồng càng nhiều chơi game càng
                        vui.
                      </p>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
          <div className='release-items'>
            {PAGINATION_ARR.map((element, idx) => {
              return (
                <PaginationItem
                  key={idx}
                  isActive={index === idx}
                  clazz={element.clazz}
                  content={element.content}
                  handleClick={() => {
                    handleClickPagination(idx);
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default GameInfoSection;

const PaginationItem = ({ id, isActive, clazz, content, handleClick }: any) => {
  return (
    <div
      id={id}
      className={`release-item ${isActive ? 'active' : ''}`}
      onClick={handleClick}
    >
      <div className={`release-icon ${clazz}`}></div>
      <div className='release-label-tag mt-2'>{content}</div>
    </div>
  );
};

const PAGINATION_ARR = [
  { clazz: 'icon-connect', content: 'Tài khoản' },
  { clazz: 'icon-touch', content: 'Chơi ngay' },
  { clazz: 'icon-battery', content: 'Tối ưu' },
  { clazz: 'icon-gift', content: 'Chia sẻ' },
  { clazz: 'icon-global', content: 'Cộng đồng' },
];
